import { render, staticRenderFns } from "./optResources.vue?vue&type=template&id=006c99ca&scoped=true&"
import script from "./optResources.vue?vue&type=script&lang=js&"
export * from "./optResources.vue?vue&type=script&lang=js&"
import style0 from "./optResources.vue?vue&type=style&index=0&id=006c99ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c99ca",
  null
  
)

export default component.exports